import axios from "axios";
import { refreshToken } from "contexts/LoginContext/helpers";
import LoginContextProvider from "contexts/LoginContext/LoginContext";
import ReactDOM from "react-dom";
import App from "./App";
import { REFRESH_TOKEN_KEY } from "./contexts/LoginContext/constants";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.response.use(
  response => response,
  async error => {
    const storedRefreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

    // If the error code is 401 Unauthorized and we have a refresh token, try to refresh the token
    if (error.response.status === 401 && storedRefreshToken) {
      try {
        await refreshToken();
        const originalRequest = error.config;
        originalRequest.headers.Authorization = axios.defaults.headers.common.Authorization;
        return axios(originalRequest);
      } catch (err) {
        // If refresh token fails, return the original error
        return Promise.reject(error);
      }
    }

    // Otherwise, return the original error
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <LoginContextProvider>
    <App />
  </LoginContextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
